var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscribeLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 405,
    viewBox: "0 0 440 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6032 362.057C59.9341 392.095 88.3696 405.893 120.807 403.755C178.923 399.923 204.922 370.275 242.305 358.416C279.687 346.556 305.863 364.731 342.229 366.986C370.615 368.747 411.165 344.726 428.716 301.438C443.809 264.21 444.859 225.831 410.819 185.499C377.32 145.447 331.353 146.74 293.635 106.217C255.918 65.6944 256.135 20.765 206.389 5.91328C167.499 -5.69737 87.3564 6.69989 55.639 58.0611C30.1274 99.373 49.6248 149.545 28.554 192.881C7.48312 236.217 -1.43201 256.272 1.97423 280.343C6.68314 313.619 12.0866 337.511 33.6032 362.057Z",
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeLasso);
export default __webpack_public_path__ + "static/media/subscribe-lasso.5c4f1c138bc5d84f596c2df3668d777a.svg";
export { ForwardRef as ReactComponent };